import type { PostHog } from "posthog-js";

export const SHREDDED_AA_VARIANT_PROPERTY = "shredded_aa_variant";

type ShreddedAaVariant = "control" | "test";
type ShreddedAaSetOnceProperty = Record<
  typeof SHREDDED_AA_VARIANT_PROPERTY,
  ShreddedAaVariant
>;

interface GetShreddedAaSetOncePropertyArgs {
  posthog: Pick<PostHog, "getFeatureFlag">;
}

const isShreddedAaVariant = (variant: unknown): variant is ShreddedAaVariant =>
  variant === "control" || variant === "test";

export const getShreddedAaSetOnceProperty = ({
  posthog,
}: GetShreddedAaSetOncePropertyArgs): ShreddedAaSetOnceProperty | undefined => {
  const variant = posthog.getFeatureFlag("shredded-AA-Test");
  if (!isShreddedAaVariant(variant)) {
    return undefined;
  }

  return { [SHREDDED_AA_VARIANT_PROPERTY]: variant };
};
